import { getAllSavedItems } from "../../../js/api/saved-items";
import { handleAddToCompare } from '../../../js/api/compare';
import { isMobile } from '../../../js/modules/utilities';
import { closeQuickAction } from '../../../js/components/other-actions';

// main navigation
const body = document.querySelector('body');
const navItems = document.querySelectorAll('.nav__item.has-subnav');
const stateItems = document.querySelectorAll('.communities__states--link');
const marketItems = document.querySelectorAll('[data-metroareaname]');
const communitiesNavBack = document.querySelector('.communities__markets--back .nav-back');
const subNavBack = document.querySelectorAll('.nav__item--subnav-actions .nav-back');
const subNavs = document.querySelectorAll('.nav__item--subnav');

const navSearch = document.querySelector('.nav__search');
const searchModal = document.querySelector('.modal-search');
const searchModalClose = document.querySelector('.modal-search__close');
const filterGroup = document.querySelectorAll('.apartment-filters__group');
const toggleFilters = document.querySelector('.toggleFilters');

const ctaContainer = document.querySelector('.communities__markets--cta');
const ctaSource = document.querySelector('.communities__markets--cta picture source');
const ctaImage = document.querySelector('.communities__markets--cta picture img');
const ctaContent = document.querySelector('.communities__markets--cta .cta-text p');

const savedItemsContainer = document.getElementById('saved-items-container');
const savedItemsBtn = document.getElementById('quick-access-button');
const savedItemsBtnMobile = document.getElementById('quick-access-button-mobile');

const recentlyViewedBtn = document.getElementById('recently-viewed-button');
const recentlyViewedBackBtn = document.getElementById('recently-viewed-back')
const recentlyViewedCloseBtn = document.getElementById('recently-viewed-close')
const recentlyViewedList = document.getElementById('recently-viewed-list');

const hamburger = document.querySelector('.hamburger');
const nav = document.querySelector('.nav');

let navMenu;
let recentlyViewedCommunitiesList;
let recentlyViewedArrowLeft;
let recentlyViewedArrowRight;

if (recentlyViewedList) {
  recentlyViewedCommunitiesList = recentlyViewedList.querySelector('.saved-items-content__communities-list');
  recentlyViewedArrowLeft = recentlyViewedList.querySelector('#recently-viewed-arrow-left');
  recentlyViewedArrowRight = recentlyViewedList.querySelector('#recently-viewed-arrow-right');
  recentlyViewedList.addEventListener('click', (e) => e.stopPropagation());
}

const communities = document.querySelector('.communities');
let defaultImg;
let defaultImgAlt;
let defaultTitle;
let defaultText;
let defaultHref;
if (communities) {
  defaultImg = communities.getAttribute('data-genericctaimage');
  defaultImgAlt = communities.getAttribute('data-genericimagealt');
  defaultTitle = communities.getAttribute('data-genericctatitle');
  defaultText = communities.getAttribute('data-genericctatext');
  defaultHref = communities.getAttribute('data-genericctahref');
}

let stateCtaImgSrc;
let stateCtaTitle;
let stateCtaText;
let stateCtaImgAlt;
let stateCtaHref;
let activeSubnav = null;

// const cloudinary = 'https://res.cloudinary.com/maa/image/upload/c_lfill,g_center,f_auto,q_auto:eco,h_451,w_689/v1/maac';

if (nav) {
  navMenu = nav.querySelector('.nav__menu');
}

const preloadImage = (url, callback) => {
  const img = new Image();
  img.src = url;
  img.onload = callback;
};

const handleNavClick = (el) => {
  el.preventDefault();
  el.stopPropagation();
  closeSavedItems();
  const li = el.target.closest('li');
  // const subNav = el.target.nextElementSibling;
  const subNav = li && li.querySelector('.nav__item--subnav');
  const subNavActive = document.querySelector('.nav__item--subnav.active');
  if (subNavActive && subNavActive !== subNav) subNavActive.classList.remove('active');

  if (subNav) {
    if (subNav.classList.contains('active')) {
      subNav.classList.remove('active');
      navSearch.classList.remove('nav__search--hidden');
    } else {
      navSearch.classList.add('nav__search--hidden');
      subNav.classList.add('active');
      setTimeout(() => {
        document.body.addEventListener('click', closeSubNav);
      }, 0);
    }
  }
};

const closeSubNav = () => {
  const subNavActive = document.querySelectorAll('.nav__item--subnav.active');
  subNavActive.forEach(item => item.classList.remove('active'));
  navSearch.classList.remove('nav__search--hidden');
  document.body.removeEventListener('click', closeSubNav);
}

const handleStateClick = (e) => {
  e.preventDefault();
  const toggleState = e.srcElement === activeSubnav;
  const currentState = document.querySelectorAll('.communities__states ul li .active');
  let target;

  const stateText = e.srcElement.innerText;
  document.querySelector('.communities__markets > h3 > span').innerText = stateText;

  currentState.forEach((item) => {
    item.classList.remove('active');
    target = document.querySelector(item.attributes.href.textContent);
    target.classList.remove('active');
  });

  if (!toggleState) {
    const el = e.srcElement;
    stateCtaImgSrc = el.getAttribute('data-statectaimage');
    stateCtaTitle = el.getAttribute('data-statectatitle');
    stateCtaText = el.getAttribute('data-statectatext');
    stateCtaImgAlt = el.getAttribute('data-statectaimagealt');
    stateCtaHref = el.getAttribute('data-statectahref');

    const srcset = stateCtaImgSrc.length > 0 ? stateCtaImgSrc : `${defaultImg} 1X`;
    const src = stateCtaImgSrc.length > 0 ? stateCtaImgSrc : defaultImg;
    const alt = stateCtaImgAlt.length > 0 ? stateCtaImgAlt : defaultImgAlt;
    const cta = `<span>${stateCtaTitle}</span>${stateCtaText}`;
    const href = stateCtaHref && stateCtaHref.length > 0 ? stateCtaHref : defaultHref;

    ctaContainer.setAttribute('href', href);
    ctaContainer.classList.add('imgTransition');

    preloadImage(stateCtaImgSrc.length > 0 ? stateCtaImgSrc : defaultImg, () => {
      ctaSource.setAttribute('srcset', srcset);
      ctaImage.setAttribute('src', src);
      ctaImage.setAttribute('alt', alt);
      ctaContent.innerHTML = cta;
      ctaContent.parentElement.classList.toggle('active', stateCtaText.length > 0 && stateCtaTitle.length > 0);
      ctaContainer.classList.remove('imgTransition');
    });

    el.classList.add('active');
    target = document.querySelector(el.attributes.href.textContent);
    target.classList.add('active');
    document.querySelector('.communities__markets').classList.add('active');
    activeSubnav = el;

    // const propertyLinks = target.querySelectorAll('a');
    // const linkArray = [];
    // const scrollLinks = document.querySelectorAll('.communities__markets--scroll > a');

    // propertyLinks.forEach((item) => {
    //   if (linkArray.indexOf(item.textContent.substring(0, 1)) === -1) linkArray.push(item.textContent.substring(0, 1));
    // });

    // scrollLinks.forEach((link) => {
    //   linkArray.indexOf(link.getAttribute('data-letter')) !== -1 ? link.classList.add('active') : link.classList.remove('active');
    // });
  } else {
    document.querySelector('.communities__markets').classList.remove('active');
    activeSubnav = null;
  }
};

const handleHamburger = (e) => {
  if (navMenu.classList.contains('nav__menu-open')) {
    document.body.classList.remove('body--scroll-locked');
    recentlyViewedCloseAction();
    handleCommunitiesBack(e);
  } else {
    document.body.classList.add('body--scroll-locked');
  }
  if (e) {
    if (e.currentTarget.classList.contains('is-active')) {
      e.currentTarget.classList.remove('is-active');
      if (savedItemsContainer) {
        savedItemsContainer.classList.remove('hide-actions');
      }
    } else {
      e.currentTarget.classList.add('is-active');
    }
  } else {
    const hamburger = document.querySelector('.hamburger.hamburger--spin');
    if (hamburger) {
      hamburger.classList.toggle('is-active');
    }
  }
  nav.classList.toggle('nav-open');
  navMenu.classList.toggle('nav__menu-open');
};

const handleCommunitiesBack = (e) => {
  e.preventDefault();
  const activeMarkets = document.querySelector('.markets.active');
  if (activeMarkets) {
    activeMarkets.classList.remove('active');
  }
  const communitiesMarkets = document.querySelector('.communities__markets');
  if (communitiesMarkets) {
    communitiesMarkets.classList.remove('active');
  }
};

const handleStatesBack = (e) => {
  const navItem = document.querySelector('.nav__item--subnav.active');
  if (navItem) {
    e.preventDefault();
    navItem.classList.remove('active');
    navSearch.classList.remove('nav__search--hidden');
  }
};

const handleMarketHover = (e) => {
  const el = e.srcElement;
  const marketCtaImgSrc = el.getAttribute('data-metroareactaimage');
  const marketCtaTitle = el.getAttribute('data-metroareactatitle');
  const marketCtaText = el.getAttribute('data-metroareactatext');
  const marketCtaImgAlt = el.getAttribute('data-metroareactaimagealt');

  let src;
  let alt;
  let title;
  let text;

  if (marketCtaImgSrc && marketCtaImgSrc.length > 0) {
    src = marketCtaImgSrc;
  } else if (stateCtaImgSrc && stateCtaImgSrc.length > 0) {
    src = stateCtaImgSrc;
  } else {
    src = defaultImg;
  }

  const srcset = `${src} 1X`;

  if (marketCtaImgAlt && marketCtaImgAlt.length > 0) {
    alt = marketCtaImgAlt;
  } else if (stateCtaImgAlt && stateCtaImgAlt.length > 0) {
    alt = stateCtaImgAlt;
  } else {
    alt = defaultImgAlt;
  }

  if (marketCtaTitle && marketCtaTitle.length > 0) {
    title = marketCtaTitle;
  } else if (stateCtaTitle && stateCtaTitle.length > 0) {
    title = stateCtaTitle;
  } else {
    title = defaultTitle;
  }

  if (marketCtaText && marketCtaText.length > 0) {
    text = marketCtaText;
  } else if (stateCtaText.length > 0) {
    text = stateCtaText;
  } else {
    text = defaultText;
  }

  const cta = `<span>${title}</span>${text}`;

  ctaContainer.classList.add('imgTransition');

  preloadImage(marketCtaImgSrc.length > 0 ? marketCtaImgSrc : defaultImg, () => {
    ctaSource.setAttribute('srcset', srcset);
    ctaImage.setAttribute('src', src);
    ctaImage.setAttribute('alt', alt);
    ctaContent.innerHTML = cta;
    ctaContent.parentElement.classList.toggle('active', marketCtaText.length > 0 && marketCtaTitle.length > 0);
    ctaContainer.classList.remove('imgTransition');
  });
};

const onRecentlyViewedBtnClickHandler = (e) => {
  e.preventDefault();
  e.stopPropagation();
  closeSubNav();
  if (savedItemsBtn) {
    savedItemsBtn.classList.remove('nav__quick-access-active');
  }
  if (savedItemsContainer) {
    savedItemsContainer.classList.remove('show');
  }
  if (recentlyViewedList && recentlyViewedBtn) {
    recentlyViewedClickAction();
  }
}

const recentlyViewedCloseAction = () => {
  recentlyViewedBtn.classList.remove('nav__quick-access-active');
  recentlyViewedList.classList.remove('show');
}

const recentlyViewedClickAction = () => {
  if (recentlyViewedList.classList.contains('show')) {
    recentlyViewedCloseAction();
  } else {
    recentlyViewedBtn.classList.add('nav__quick-access-active');
    recentlyViewedList.classList.add('show');
    recentlyViewedList.querySelector('.saved-items-content__communities-list').scrollLeft = 0;
    if (!isMobile) {
      renderArrows();
      setTimeout(() => {
        document.addEventListener('click', closeSavedItems);
      }, 0);
    }
  }
}

const closeSavedItems = () => {
  if (savedItemsBtn) {
    savedItemsBtn.classList.remove('nav__quick-access-active');
  }
  if (savedItemsContainer) {
    savedItemsContainer.classList.remove('show');
  }
  if (recentlyViewedBtn) {
    recentlyViewedBtn.classList.remove('nav__quick-access-active');
  }
  if (recentlyViewedList) {
    recentlyViewedList.classList.remove('show');
  }
  document.removeEventListener('click', closeSavedItems);
}

const onSavedItemsMobileClickHandler = (e) => {
  handleHamburger();
  onSavedItemsClickHandler(e);
  if (savedItemsContainer) {
    savedItemsContainer.classList.add('hide-actions');
  }
}

const onSavedItemsClickHandler = (e) => {
  e.preventDefault();
  e.stopPropagation();
  closeSubNav();
  closeQuickAction();
  if (recentlyViewedBtn) {
    recentlyViewedBtn.classList.remove('nav__quick-access-active');
  }
  if (recentlyViewedList) {
    recentlyViewedList.classList.remove('show');
  }
  if (savedItemsContainer && savedItemsBtn) {
    savedItemsBtn.classList.toggle('nav__quick-access-active');

    if (savedItemsContainer.classList.contains('show')) {
      savedItemsContainer.classList.remove('show');
    } else {
      savedItemsContainer.classList.add('show');
      const customEvent = new CustomEvent('savedItemsOpened', { bubbles: true });
      savedItemsContainer.dispatchEvent(customEvent);
      setTimeout(() => {
        document.addEventListener('click', closeSavedItems);
      }, 0);
    }
  }
}

stateItems.forEach((item) => {
  item.addEventListener('click', handleStateClick);
});

if (communitiesNavBack) {
  communitiesNavBack.addEventListener('click', handleCommunitiesBack);
}

subNavBack.forEach((item) => {
  item.addEventListener('click', handleStatesBack);
});

subNavs.forEach((item) => item.addEventListener('click', (e) => e.stopPropagation()));

navItems.forEach((item) => {
  item.addEventListener('click', handleNavClick);
});

if (hamburger) {
  hamburger.addEventListener('click', handleHamburger);
}

marketItems.forEach((item) => {
  item.addEventListener('mouseover', handleMarketHover);
});

if (savedItemsBtn) {
  savedItemsBtn.addEventListener('click', onSavedItemsClickHandler);
}

if (savedItemsBtnMobile) {
  savedItemsBtnMobile.addEventListener('click', onSavedItemsMobileClickHandler);
}

if (recentlyViewedBtn) {
  recentlyViewedBtn.addEventListener('click', onRecentlyViewedBtnClickHandler)
}

if (recentlyViewedBackBtn) {
  recentlyViewedBackBtn.addEventListener('click', recentlyViewedClickAction);
}

if (recentlyViewedCloseBtn) {
  recentlyViewedCloseBtn.addEventListener('click', recentlyViewedClickAction);
}

if (recentlyViewedArrowLeft) {
  recentlyViewedArrowLeft.addEventListener('click', () => {
    recentlyViewedCommunitiesList.scrollBy({
      top: 0,
      left: -152,
      behavior: 'smooth',
    });
  });
}

if (recentlyViewedArrowRight) {
  recentlyViewedArrowRight.addEventListener('click', () => {
    recentlyViewedCommunitiesList.scrollBy({
      top: 0,
      left: 152,
      behavior: 'smooth',
    });
  });
}

if (recentlyViewedCommunitiesList) {
  recentlyViewedCommunitiesList.addEventListener('scrollend', () => {
    renderArrows();
  });
}

if (recentlyViewedList) {
  recentlyViewedList.querySelectorAll('.plus-btn').forEach(el => {
    el.addEventListener('click', (e) => {
      const item = e.currentTarget.closest('.saved-items-content__communities-list__item-actions');
      const communityId = e.currentTarget.getAttribute('data-id');

      e.currentTarget.remove();
      const divAddedToCompare = document.createElement('div');
      divAddedToCompare.classList.add('added-to-compare');
      divAddedToCompare.innerHTML = `
      <svg><use xlink:href="#checkmark"></use></svg>
      <span>Added to Compare</span>
    `;
      item.appendChild(divAddedToCompare);
      const communityIndex = communitiesArray && communitiesArray.communities && communitiesArray.communities.findIndex( obj => {
        return obj.Id === communityId;
      });

      if (communityIndex > -1) {
        communitiesArray.communities[communityIndex].IsCompare = true;
      }


      if(window.location.hostname !== 'localhost'){
        handleAddToCompare(communityId);
      }
    })
  })
}

const renderArrows = () => {
  if (recentlyViewedList) {
    const el = recentlyViewedList.querySelector('.saved-items-content__communities-list');
    const leftArrow = recentlyViewedList.querySelector('#recently-viewed-arrow-left');
    const rightArrow = recentlyViewedList.querySelector('#recently-viewed-arrow-right');
    const canScrollLeft = el.scrollLeft > 0;
    const canScrollRight = el.scrollLeft !== el.scrollWidth - el.clientWidth;
    if (canScrollLeft && leftArrow) {
      leftArrow.classList.add('active')
    } else {
      leftArrow.classList.remove('active');
    }
    if (canScrollRight && rightArrow) {
      rightArrow.classList.add('active');
    } else {
      rightArrow.classList.remove('active');
    }
  }
}

const searchOpen = () => {
  searchModal.classList.add('modal-search--open');
  body.classList.add('body--scroll-locked');
}

if (navSearch) {
  navSearch.addEventListener('click', searchOpen);
}

const searchClose = () => {
  searchModal.classList.remove('modal-search--open');
  body.classList.remove('body--scroll-locked');
}

if (searchModalClose) {
  searchModalClose.addEventListener('click', searchClose);
}



// WEBPACK FOOTER //
// ./src/templates/components/nav-header/nav-header.js